export default "__VITE_ASSET__BwEPgyrO__"